export default __webpack_public_path__ + "static/media/dinventory.b74301af.png";